import { AllContextualConstants } from "./contextual-media.constants";
import axios from 'axios';
import { config } from '../../../helpers'
import { formatDateDisplay, toFormData } from '../../../components/utilities/customFunctions'
import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import { point as turfPoint, polygon as turfPolygon } from '@turf/helpers';

const ROOT_URL = config.apiServer;
const ROOT_URL_API = ROOT_URL + "/api";

export const getDealType = (accountId, decarbonise = false, channel = "") => {
    return getDealTypes(accountId, "GET_DEAL_TYPE", decarbonise, channel)
}
export const getDealTypePop = (accountId, decarbonise = false, channel = "") => {
    return getDealTypes(accountId, "GET_DEAL_TYPE_POP", decarbonise, channel)
}


export const getDealTypes = (accountId, constant = "GET_DEAL_TYPE", decarbonise = false, channel = "") => {
    return (dispatch) => {
        dispatch(dealTypeloading(true));
        axios.get(`${ROOT_URL_API}/get-dealType?accountId=${accountId}&decarbonise=${decarbonise}&channel=${channel}`, { headers: { Authorization: config.authToken() } })
            .then(response => {
                if (response.data && response.data.success) {
                    dispatch({
                        type: AllContextualConstants[constant],
                        payload: response.data.data
                    });
                }
                else {
                    dispatch({
                        type: AllContextualConstants[constant + "_ERROR"],
                        payload: "error"
                    });
                }
                dispatch(dealTypeloading(false));
            }).catch(() => {
                dispatch({
                    type: AllContextualConstants[constant + "_ERROR"],
                    payload: "error"
                });
                dispatch(dealTypeloading(false));
            })
    }
}

const dealTypeloading = (status) => {
    return {
        type: AllContextualConstants.DEAL_TYPE_LOADING,
        payload: status
    };
};

export const emptyDealType = () => {
    return (dispatch) => {
        dispatch({ type: AllContextualConstants.EMPTY_DEAL_TYPE, payload: "" });
    }
}
export const emptyDealTypePop = () => {
    return (dispatch) => {
        dispatch({ type: AllContextualConstants.EMPTY_DEAL_TYPE_POP, payload: "" });
    }
}

export const getDealTypeFormatCarousel = (dealTypeFormatId) => {
    return (dispatch) => {
        dispatch(dealTypeFormatCarouselLoading(true));
        axios.get(`${ROOT_URL_API}/format-carousel-dealTypeFormatId?dealTypeFormatId=${dealTypeFormatId}`, { headers: { Authorization: config.authToken() } })
            .then(response => {

                if (response.data && response.data.success) {
                    dispatch({
                        type: AllContextualConstants.GET_DEAL_TYPE_FORMAT_CAROUSEL,
                        payload: response.data.data
                    });
                }
                else {
                    dispatch({
                        type: AllContextualConstants.GET_DEAL_TYPE_FORMAT_CAROUSEL_ERROR,
                        payload: "error"
                    });
                }
                dispatch(dealTypeFormatCarouselLoading(false));
            }).catch(() => {
                dispatch({
                    type: AllContextualConstants.GET_DEAL_TYPE_FORMAT_CAROUSEL_ERROR,
                    payload: "error"
                });
                dispatch(dealTypeFormatCarouselLoading(false));
            })
    }
}

const dealTypeFormatCarouselLoading = (status) => {
    return {
        type: AllContextualConstants.DEAL_TYPE_FORMAT_CAROUSEL_LOADING,
        payload: status
    };
};

export const emptyDealTypeFormatCarousel = () => {
    return (dispatch) => {
        dispatch({ type: AllContextualConstants.EMPTY_DEAL_TYPE_FORMAT_CAROUSEL, payload: "" });
    }
}



export const saveSelectedDealTypeInfo = (values) => dispatch => {
    dispatch(loading(true));

    axios.post(`${ROOT_URL_API}/contextual/create-deal`,
        toFormData({

            accountId: typeof values.account == "object" ? values.account.id : values.account,
            name: values.name,
            dspId: typeof values.dsp == "object" ? values.dsp.network_id : values.dsp,
            dsp_buyer_id: typeof values.dsp_buyer_id == "object" ? values.dsp_buyer_id.buyerId : values.dsp_buyer_id,
            dealType: typeof values.selectedDealType == "object" ? values.selectedDealType.id : values.selectedDealType,
            is_mobile_app: typeof values.is_mobile_app == "object" ? values.is_mobile_app.value : values.is_mobile_app,
            addonId: values.addonIds || "",
            measure_emissions: values.measure_emissions,
            decarbonise: typeof values.decarbonise == "object" ? values.decarbonise.value : values.decarbonise,
            decarbonise_options: JSON.stringify(values.decarbonise_options),
            net_media_bugdet: values.net_media_bugdet || "",
            campaign_dates: getDates(values.campaign_dates),
            is_managed_service: values.is_managed_service || false,
            ...(values.cpm ? { cpm: values.cpm } : {})

        }), { headers: { Authorization: config.authToken() } })
        .then(response => {
            if (response.data && response.data.success) {

                dispatch({ type: AllContextualConstants.ADD_SELECTED_DEAL_TYPE_SUCCESS, payload: response.data.data.id });
            }
            else {
                dispatch({ type: AllContextualConstants.ADD_SELECTED_DEAL_TYPE_ERROR, payload: response.data.msg + "~" + Date.now() });
            }

            dispatch(loading(false));
        }).catch(error => {
            dispatch({ type: AllContextualConstants.ADD_SELECTED_DEAL_TYPE_ERROR, payload: "Error~" + Date.now() });
            dispatch(loading(false));
        })
}


export const updateSelectedDealTypeInfo = (values, id) => dispatch => {
    dispatch(loading(true));

    axios.post(`${ROOT_URL_API}/contextual/update-deal?id=${id}`,
        toFormData({
            accountId: typeof values.account == "object" ? values.account.id : values.account,
            name: values.name,
            dspId: typeof values.dsp == "object" ? values.dsp.network_id : values.dspId,
            dsp_buyer_id: typeof values.dsp_buyer_id == "object" ? values.dsp_buyer_id.buyerId : values.dsp_buyer_id,
            dealType: typeof values.selectedDealType == "object" ? values.selectedDealType.id : values.selectedDealType,
            is_mobile_app: typeof values.is_mobile_app == "object" ? values.is_mobile_app.value : values.is_mobile_app,
            addonId: values.addonIds || "",
            measure_emissions: values.measure_emissions,
            decarbonise: typeof values.decarbonise == "object" ? values.decarbonise.value : values.decarbonise,
            decarbonise_options: JSON.stringify(values.decarbonise_options),
            net_media_bugdet: values.net_media_bugdet || "",
            campaign_dates: getDates(values.campaign_dates),
            is_managed_service: values.is_managed_service || false,
            ...(values.cpm ? { cpm: values.cpm } : {})

        }), { headers: { Authorization: config.authToken() } })
        .then(response => {
            if (response.data && response.data.success) {

                dispatch({ type: AllContextualConstants.UPDATE_SELECTED_DEAL_TYPE_SUCCESS, payload: response.data.data.id + "~" + Date.now() });
            }
            else {
                dispatch({ type: AllContextualConstants.UPDATE_SELECTED_DEAL_TYPE_ERROR, payload: response.data.msg + "~" + Date.now() });
            }

            dispatch(loading(false));
        }).catch(error => {
            dispatch({ type: AllContextualConstants.UPDATE_SELECTED_DEAL_TYPE_ERROR, payload: "Error~" + Date.now() });
            dispatch(loading(false));
        })
}


export const updateDealPlan = (values, id) => dispatch => {
    dispatch(loading(true));

    axios.post(`${ROOT_URL_API}/contextual/update-deal-plan/${id}`,
        toFormData({
            net_media_bugdet: values.net_media_bugdet || "",
            campaign_dates: getDates(values.campaign_dates),
        }), { headers: { Authorization: config.authToken() } })
        .then(response => {
            if (response.data && response.data.success) {

                dispatch({ type: AllContextualConstants.UPDATE_SELECTED_DEAL_PLAN_SUCCESS, payload: response.data.data.id + "~" + Date.now() });
            }
            else {
                dispatch({ type: AllContextualConstants.UPDATE_SELECTED_DEAL_PLAN_ERROR, payload: response.data.msg + "~" + Date.now() });
            }

            dispatch(loading(false));
        }).catch(error => {
            dispatch({ type: AllContextualConstants.UPDATE_SELECTED_DEAL_PLAN_ERROR, payload: "Error~" + Date.now() });
            dispatch(loading(false));
        })
}



const loadingCheckToken = (status) => {
    return {
        type: AllContextualConstants.CHECK_TOKEN_LOADING,
        payload: status
    };
};
export const checkDealTokenExist = (id, ftt) => {
    return (dispatch) => {
        dispatch(loadingCheckToken(true));

        axios.get(`${ROOT_URL_API}/check_deal_token_exists?accountid=${id}&format_type_tier=${ftt}`, { headers: { Authorization: config.authToken() } })
            .then(response => {
                if (response.data && response.data.success) {
                    dispatch({ type: AllContextualConstants.CHECK_TOKEN, payload: response.data });
                }
                else {
                    dispatch({ type: AllContextualConstants.CHECK_TOKEN_ERROR, payload: response.data ? response.data.msg : "Error" });
                }
                dispatch(loadingCheckToken(false));
            }).catch(() => {
                dispatch({ type: AllContextualConstants.CHECK_TOKEN_ERROR, payload: false });
                dispatch(loadingCheckToken(false));
            });
    };
}
export const emptyDealToken = () => dispatch => {
    dispatch({
        type: AllContextualConstants.CHECK_TOKEN,
        payload: ""
    });
}

export const getContextualById = (id, param = "") => {
    return (dispatch) => {
        dispatch(loading(true));

        axios.get(`${ROOT_URL_API}/contextual/deal-info?id=${id}&${param}`, { headers: { Authorization: config.authToken() } })
            .then(response => {
                if (response.data && response.data.success) {
                    dispatch({ type: AllContextualConstants.GET_CONTEXUAL_MEDIA_AD_BY_ID, payload: response.data.data });
                }
                else {
                    dispatch({ type: AllContextualConstants.GET_CONTEXUAL_MEDIA_AD_BY_ID_ERROR, payload: response.data ? response.data.msg : "Error" });
                }
                dispatch(loading(false));
            }).catch(() => {
                dispatch({ type: AllContextualConstants.GET_CONTEXUAL_MEDIA_AD_BY_ID_ERROR, payload: false });
                dispatch(loading(false));
            });
    };
}
const getDates = (dates) => dates?.start ? JSON.stringify({ start: formatDateDisplay(dates?.start), end: formatDateDisplay(dates?.end) }) : ""
export const emptyDealData = () => dispatch => {
    dispatch({
        type: AllContextualConstants.EMPTY_CONTEXUAL_MEDIA_AD_DATA,
        payload: ""
    });
}

const loading = (status) => {
    return {
        type: AllContextualConstants.SELECTED_CONTEXUAL_MEDIA_LOADING,
        payload: status
    };
};


export const getPreDefineMedias = (dealTypeId, decarbonise = "") => {
    return (dispatch) => {
        dispatch(preDefineMediasloading(true));
        //let url = `predefined_media_master`
        let url = `prebuilt_media_master`
        if (decarbonise && !config.commbank) {
            url = `g_prebuilt_media_master`
        }
        axios.get(`${ROOT_URL_API}/${url}?dealTypeId=${dealTypeId}`, { headers: { Authorization: config.authToken() } })
            .then(response => {

                if (response.data && response.data.success) {
                    let array = response.data.data

                    let preBuilt = array.filter(function (el) {
                        return !el.provider_id && !el.provider
                    });

                    let preBehave = array.filter(function (el) {

                        if (el.provider_id && el.provider) {
                            el.topSites = response.data.topSites || "";
                            return true;
                        }
                        return false;

                    });

                    dispatch({
                        type: AllContextualConstants.GET_PRE_DEFINE_MEDIAS,
                        payload: { preDefineMedias: preBuilt, preDefineMediasBehave: preBehave }
                    });
                }
                else {
                    dispatch({
                        type: AllContextualConstants.GET_PRE_DEFINE_MEDIAS_ERROR,
                        payload: "error"
                    });
                }
                dispatch(preDefineMediasloading(false));
            }).catch(() => {
                dispatch({
                    type: AllContextualConstants.GET_PRE_DEFINE_MEDIAS_ERROR,
                    payload: "error"
                });
                dispatch(preDefineMediasloading(false));
            })
    }
}

const preDefineMediasloading = (status) => {
    return {
        type: AllContextualConstants.GET_PRE_DEFINE_MEDIAS_LOADING,
        payload: status
    };
};

export const emptyPreDefineMedias = () => {
    return (dispatch) => {
        dispatch({ type: AllContextualConstants.EMPTY_PRE_DEFINE_MEDIAS, payload: "" });
    }
}



export const getBespokeMedias = (dealTypeId, accountId, decarbonise = "") => {
    return (dispatch) => {
        dispatch(bespokeloading(true));
        axios.get(`${ROOT_URL_API}/bespoke_media_master?dealTypeId=${dealTypeId}&accountId=${accountId}&decarbonise=${decarbonise}`, { headers: { Authorization: config.authToken() } })
            .then(response => {

                if (response.data && response.data.success) {
                    dispatch({
                        type: AllContextualConstants.GET_BESPOKE_MEDIAS,
                        payload: response.data.data
                    });
                }
                else {
                    dispatch({
                        type: AllContextualConstants.GET_BESPOKE_MEDIAS_ERROR,
                        payload: "error"
                    });
                }
                dispatch(bespokeloading(false));
            }).catch(() => {
                dispatch({
                    type: AllContextualConstants.GET_BESPOKE_MEDIAS_ERROR,
                    payload: "error"
                });
                dispatch(bespokeloading(false));
            })
    }
}


export const changeBespokeStatus = (values) => dispatch => {
    dispatch(bespokeStatusLoading(true));

    axios.post(`${ROOT_URL_API}/change_bespoke_status/${values.id}`,
        toFormData({
            status: !values.status

        }), { headers: { Authorization: config.authToken() } })
        .then(response => {
            if (response.data && response.data.success) {

                dispatch({ type: AllContextualConstants.UPDATE_BESPOKE_STATUS_SUCCESS, payload: response.data.data.id + "~" + Date.now() });
            }
            else {
                dispatch({ type: AllContextualConstants.UPDATE_BESPOKE_STATUS_ERROR, payload: response.data.msg + "~" + Date.now() });
            }

            dispatch(bespokeStatusLoading(false));
        }).catch(error => {
            dispatch({ type: AllContextualConstants.UPDATE_BESPOKE_STATUS_ERROR, payload: "Error~" + Date.now() });
            dispatch(bespokeStatusLoading(false));
        })
}

const bespokeStatusLoading = (status) => {
    return {
        type: AllContextualConstants.UPDATE_BESPOKE_STATUS_LOADING,
        payload: status
    };
}

const bespokeloading = (status) => {
    return {
        type: AllContextualConstants.GET_BESPOKE_MEDIAS_LOADING,
        payload: status
    };
};


const loadingForecast = (status) => {
    return {
        type: AllContextualConstants.GET_FORECAST_LOADING,
        payload: status
    };
};

const loadingScreens = (status) => {
    return {
        type: AllContextualConstants.GET_SCREENS_LOADING,
        payload: status
    };
};

const loadingValues = (status) => {
    return {
        type: AllContextualConstants.GET_VALUES_LOADING,
        payload: status
    };
};

export const emptyBespokeMedias = () => {
    return (dispatch) => {
        dispatch({ type: AllContextualConstants.EMPTY_BESPOKE_MEDIAS, payload: "" });
    }
}

export const saveselectedMedias = (values, id, accountId = "", deOp, version = "v2", token = false) => dispatch => {
    dispatch(loading(true));
    axios.post(`${ROOT_URL_API}/save-selected-medias-${version}/${id}?accountId=${accountId}`,
        toFormData({
            contextual_media: JSON.stringify(token ? [] : values),
            decarbonise_options: JSON.stringify({ ...deOp }),
            use_existing_token: token
        }), { headers: { Authorization: config.authToken() } })
        .then(response => {
            if (response.data && response.data.success) {

                dispatch({ type: AllContextualConstants.ADD_SELECTED_MEDIAS_SUCCESS, payload: response.data.data.id });
            }
            else {
                dispatch({ type: AllContextualConstants.ADD_SELECTED_MEDIAS_ERROR, payload: response.data.msg + "~" + Date.now() });
            }

            dispatch(loading(false));
        }).catch(error => {
            dispatch({ type: AllContextualConstants.ADD_SELECTED_MEDIAS_ERROR, payload: "Error~" + Date.now() });
            dispatch(loading(false));
        })
}

export const getBespokeCategories = (dealTypeId, decarbonise = false, sortBy = "adRequests", sortValue = "desc") => {
    return (dispatch) => {
        dispatch(bespokeCategoriesloading(true));
        //axios.get(`${ROOT_URL_API}/category?isAvailableForBespoke=true&dealTypeId=${dealTypeId}&sortBy=${sortBy}&sortValue=${sortValue}`, { headers: { Authorization: config.authToken() } })
        axios.get(`${ROOT_URL_API}/${decarbonise ? "g_bespoke_dictionary" : "bespoke_dictionary"}?dealTypeId=${dealTypeId}&sortBy=${sortBy}&sortValue=${sortValue}`, { headers: { Authorization: config.authToken() } })
            .then(response => {

                if (response.data && response.data.success) {
                    dispatch({
                        type: AllContextualConstants.GET_BESPOKE_CATEGORIES,
                        payload: response.data.data
                    });
                }
                else {
                    dispatch({
                        type: AllContextualConstants.GET_BESPOKE_CATEGORIES_ERROR,
                        payload: "error"
                    });
                }
                dispatch(bespokeCategoriesloading(false));
            }).catch(() => {
                dispatch({
                    type: AllContextualConstants.GET_BESPOKE_CATEGORIES_ERROR,
                    payload: "error"
                });
                dispatch(bespokeCategoriesloading(false));
            })
    }
}

const bespokeCategoriesloading = (status) => {
    return {
        type: AllContextualConstants.GET_BESPOKE_CATEGORIES_LOADING,
        payload: status
    };
};

export const emptyBespokeCategories = () => {
    return (dispatch) => {
        dispatch({ type: AllContextualConstants.EMPTY_BESPOKE_CATEGORIES, payload: "" });
    }
}



export const saveBespokeMedia = (values) => dispatch => {
    dispatch(loading(true));
    axios.post(`${ROOT_URL_API}/bespoke_media_master`,
        toFormData({
            accountId: values.accountId,
            name: values.name,
            card: values.card,
            description: values.description,
            estimated_emissions: values.estimated_emissions,
            decarbonise: values.decarbonise,
            topSites: values.topSites,
            uniqueVisitors: values.uniqueVisitors,
            adRequests: values.adRequests,
            audienceFact: values.audienceFact,
            audienceBehavior: values.audienceBehavior,
            dealTypeId: values.dealTypeId,
            categoryIds: values.categoryIds,
            bespoke_status: values.bespoke_status,
            isCustomised: false
        }), { headers: { Authorization: config.authToken() } })
        .then(response => {
            if (response.data && response.data.success) {

                dispatch({ type: AllContextualConstants.ADD_BESPOKE_MEDIA_SUCCESS, payload: response.data.data.id });
            }
            else {
                dispatch({ type: AllContextualConstants.ADD_BESPOKE_MEDIA_ERROR, payload: response.data.msg + "~" + Date.now() });
            }

            dispatch(loading(false));
        }).catch(error => {
            dispatch({ type: AllContextualConstants.ADD_BESPOKE_MEDIA_ERROR, payload: "Error~" + Date.now() });
            dispatch(loading(false));
        })
}


export const updateBespokeMedia = (values, id) => dispatch => {
    dispatch(loading(true));
    axios.post(`${ROOT_URL_API}/bespoke_media_master/${id}`,
        toFormData({
            accountId: values.accountId,
            name: values.name,
            card: values.card,
            description: values.description,
            estimated_emissions: values.estimated_emissions,
            decarbonise: values.decarbonise,
            topSites: values.topSites,
            uniqueVisitors: values.uniqueVisitors,
            adRequests: values.adRequests,
            audienceFact: values.audienceFact,
            audienceBehavior: values.audienceBehavior,
            dealTypeId: values.dealTypeId,
            categoryIds: values.categoryIds,
            bespoke_status: values.bespoke_status,
            isCustomised: values.isCustomised
        }), { headers: { Authorization: config.authToken() } })
        .then(response => {
            if (response.data && response.data.success) {

                dispatch({ type: AllContextualConstants.UPDATE_BESPOKE_MEDIA_SUCCESS, payload: response.data.data + Date.now() });
            }
            else {
                dispatch({ type: AllContextualConstants.UPDATE_BESPOKE_MEDIA_ERROR, payload: response.data.msg + "~" + Date.now() });
            }

            dispatch(loading(false));
        }).catch(error => {
            dispatch({ type: AllContextualConstants.UPDATE_BESPOKE_MEDIA_ERROR, payload: "Error~" + Date.now() });
            dispatch(loading(false));
        })
}



export const acceptTnC = (id) => dispatch => {
    dispatch(loading(true));
    axios.post(`${ROOT_URL_API}/tnc/${id}`,
        toFormData({
            is_tnc_accepted: true
        }), { headers: { Authorization: config.authToken() } })
        .then(response => {
            dispatch(loading(false));
        }).catch(error => {
            console.log(error)
            dispatch(loading(false));
        })
}




// DOOH Targeting 

export const emptyLocationsTargeting = () => (dispatch) => {
    dispatch({ type: AllContextualConstants.EMPTY_DOOH_TARGETS, payload: "" });
};
export const emptyLocationsTargetingForcast = () => (dispatch) => {
    dispatch({ type: AllContextualConstants.EMPTY_DOOH_FORECAST, payload: "" });
};

export const getLocationsTargeting = (payload, firstTime = false) => (dispatch) => {
    dispatch(loading(true));
    axios.post(`${ROOT_URL_API}/outmoove/targeting`, payload, {
        headers: { Authorization: config.authToken() },
    })
        .then((response) => {
            if (response.data) {
                dispatch({
                    type: AllContextualConstants.BB_GET_DOOH_TARGETS_SUCCESS,
                    payload: response.data,
                });
                if (firstTime) {
                    dispatch({
                        type: AllContextualConstants.BB_GET_DOOH_ORIGINAL_TARGETS_SUCCESS,
                        payload: response.data
                    });
                }

            } else {
                dispatch({
                    type: AllContextualConstants.BB_GET_DOOH_TARGETS_ERROR,
                    payload: "",
                });
            }
            dispatch(loading(false));
        })
        .catch((error) => {
            dispatch({
                type: AllContextualConstants.BB_GET_DOOH_TARGETS_ERROR,
                payload: "",
            })
            dispatch(loading(false));
        }
        );
};

export const getLocationsTargetingForcast = (payload) => (dispatch) => {
    dispatch(loadingForecast(true));
    axios.post(`${ROOT_URL_API}/outmoove/targeting/forecast`, payload, {
        headers: { Authorization: config.authToken() },
    })
        .then((response) => {
            if (response.data) {
                dispatch({
                    type: AllContextualConstants.BB_GET_DOOH_FORECAST_SUCCESS,
                    payload: response.data,
                });

            } else {
                dispatch({
                    type: AllContextualConstants.BB_GET_DOOH_FORECAST_ERROR,
                    payload: "",
                });
            }
            dispatch(loadingForecast(false));
        })
        .catch((error) => {
            dispatch({
                type: AllContextualConstants.BB_GET_DOOH_FORECAST_ERROR,
                payload: "",
            })
            dispatch(loadingForecast(false));
        }
        );
};


export const getTargetingValues = (payload) => (dispatch) => {
    dispatch(loadingValues(true));
    axios.post(`${ROOT_URL_API}/outmoove/targeting/values`, payload, {
        headers: { Authorization: config.authToken() },
    })
        .then((response) => {
            if (response.data) {
                dispatch({
                    type: AllContextualConstants.BB_GET_DOOH_VALUES_SUCCESS,
                    payload: response.data,
                });

            } else {
                dispatch({
                    type: AllContextualConstants.BB_GET_DOOH_VALUES_ERROR,
                    payload: "",
                });
            }
            dispatch(loadingValues(false));
        })
        .catch((error) => {
            dispatch({
                type: AllContextualConstants.BB_GET_DOOH_VALUES_ERROR,
                payload: "",
            })
            dispatch(loadingValues(false));
        }
        );
};

export const getScreensForLocation = (payload) => (dispatch) => {
    dispatch(loadingScreens(true));
    axios.post(`${ROOT_URL_API}/outmoove/targeting`, payload, {
        headers: { Authorization: config.authToken() },
    })
        .then((response) => {
            if (response.data) {
                dispatch({
                    type: AllContextualConstants.BB_GET_SCREENS_VALUES_SUCCESS,
                    payload: response.data,
                });

            } else {
                dispatch({
                    type: AllContextualConstants.BB_GET_SCREENS_VALUES_ERROR,
                    payload: "",
                });
            }
            dispatch(loadingScreens(false));
        })
        .catch((error) => {
            dispatch({
                type: AllContextualConstants.BB_GET_SCREENS_VALUES_ERROR,
                payload: "",
            })
            dispatch(loadingScreens(false));
        }
        );
};



const DOOH_TARGETING_IDS = {
    "KG4V0g": "state",
    "O9JKGP": "city",
    "197QLd": "postcode",
    "NGNDgB": "environment_level_1",
    "qGZpgk": "id",
    "provider_d": "provider",
    "provider_r": "provider",
    "conquest": "provider",

}
const WEATHER = [
    { id: "Clear/Sunny", text: "Clear/Sunny" },
    { id: "Cloudy", text: "Cloudy" },
    { id: "Dry", text: "Dry" },
    { id: "Mist", text: "Mist" },
    { id: "Raining", text: "Raining" },
    { id: "Snowing", text: "Snowing" }
]

const COMMBANK_ME = config.kingliving ? [
    { id: "Target audiences in or near store", text: "Target audiences in or near store" },
] : [
    { id: "Target audiences in or near store", text: "Target audiences in or near store" },
    { id: "Target audiences who have visited store", text: "Target audiences who have visited store" }
]

const EXTENTION = [
    { id: "Display", text: "Display", radius: "1km" },
    { id: "Rich Media", text: "Rich Media", radius: "1km" },
    { id: "Social Amplifier", text: "Social Amplifier", radius: "1km" },
    { id: "Instream Video", text: "Instream Video", radius: "1km" },
    { id: "VOD", text: "VOD" }
]

const RETAILWOOL = [
    { id: "Woolworths", text: "Woolworths" },
    { id: "EG", text: "EG" },
    { id: "Ampol", text: "Ampol" }
]
const RETAILKING = [
    { id: "King Living Showroom", text: "King Living Showroom" },
    { id: "King Living Outlet", text: "King Living Outlet" }
]
const CONQUEST = [
    { id: "MCM House", text: "MCM House" },
    { id: "Lounge Lovers", text: "Lounge Lovers" },
    { id: "Globe West", text: "Globe West" },
    { id: "Coco Republic", text: "Coco Republic" },
    { id: "Nick Scali Showroom", text: "Nick Scali Showroom" }
]
const CONQUESTWOOL = [
    { id: "Aldi", text: "Aldi" },
    { id: "Coles", text: "Coles" },
    { id: "IGA", text: "IGA" },
]
const RETAIL = [
    { id: "Australia Post", text: "Australia Post" },
    { id: "BWS", text: "BWS" },
    { id: "Coles", text: "Coles" },
    { id: "CommBank", text: "CommBank" },
    { id: "David Jones", text: "David Jones" },
    { id: "Officeworks", text: "Officeworks" },
    { id: "Qantas", text: "Qantas" },
    { id: "Aldi", text: "Aldi" },
    { id: "IGA", text: "IGA" },
    ...RETAILWOOL,
    ...RETAILKING,
    ...CONQUEST
]
const RADIUS = [{ id: "500m", text: "500m" }, { id: "1km", text: "1km" }, { id: "2km", text: "2km" }, { id: "5km", text: "5km" }, { id: "10km", text: "10km" }]
const haversineDistance = (lat1, lon1, lat2, lon2) => {
    const toRad = deg => (deg * Math.PI) / 180;
    const R = 6371000;
    const φ1 = toRad(lat1);
    const φ2 = toRad(lat2);
    const Δφ = toRad(lat2 - lat1);
    const Δλ = toRad(lon2 - lon1);

    const a = Math.sin(Δφ / 2) ** 2 +
        Math.cos(φ1) * Math.cos(φ2) *
        Math.sin(Δλ / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
};

const createTargeting = (locations, handleKeys = false) => {
    let obj = {}
    let loc = handleKeys ? locations.map(item => ({
        ...item,
        id: item.id,
        lat: item.latitude,
        lon: item.longitude,
        nr_screens: item.number_of_screens,
    })) : locations;
    obj["locations"] = loc
    obj["values"] = []
    return obj
}
const createForecast = (locations) => {
    let obj = {}
    const totalScreens = locations.reduce((sum, item) => {
        return sum + (item.number_of_screens || 0);
    }, 0);

    const totalMobile = locations.reduce((sum, item) => {
        return sum + (item.radius || 0);
    }, 0);
    let total = {
        location_count: locations.length,
        screen_count: totalScreens,
        uncapped: { impressions: totalMobile }
    }
    obj["totals"] = total
    return obj
}

const applyPolygonFilter = (locations, features, includeMode = true) => {
    return locations.filter(loc => {
        const pt = turfPoint([parseFloat(loc.lon), parseFloat(loc.lat)]);
        const isInsideAny = features.some(feature => {
            const poly = turfPolygon(feature.geometry.coordinates);
            return booleanPointInPolygon(pt, poly);
        });
        return includeMode ? isInsideAny : !isInsideAny;
    });
};
const CONQUESTSKIP = config.mediumrare ? [] : ["King Living Showroom", "King Living Outlet", "MCM House", "Lounge Lovers", "Globe West", "Coco Republic", "Nick Scali Showroom", "Aldi", "Coles", "IGA"]
const KINGLIVINGSKIP = ["King Living Showroom", "King Living Outlet", "Woolworths", "EG", "Ampol"]

export const getCommbankTargeting = (filters = false, targetdata = false, isEdit = false, kingliving = false) => async (dispatch) => {
    dispatch(loadingForecast(true));
    dispatch(loading(true));
    let newLoc = targetdata
    let provider = config.woolworths ? "Woolworths,EG,Ampol,Aldi,Coles,IGA" : kingliving ? "King Living Showroom,King Living Outlet,MCM House,Lounge Lovers,Globe West,Coco Republic,Nick Scali Showroom" : ""
    if (isEdit) {
        await axios.get(`${ROOT_URL_API}/get_dooh_locations?provider=${provider}`, {
            headers: { Authorization: config.authToken() },
        })
            .then((response) => {
                if (response?.data?.success) {
                    newLoc = response.data.data
                    let newData = newLoc
                    newData = newLoc.filter(item => {
                        return filters.every(filter => {
                            // only apply provider_d to dooh items
                            if (filter.targeting_id === 'extention') {
                                return true;
                            }
                            if (filter.targeting_id === 'provider_d' && item.type !== 'dooh') {
                                return true;
                            }
                            // only apply provider_r to retailers
                            if (filter.targeting_id === 'provider_r' && (item.type !== 'retailers' || CONQUESTSKIP.includes(item.provider))) {
                                return true;
                            }
                            if (filter.targeting_id === 'conquest' && (item.type !== 'retailers' || KINGLIVINGSKIP.includes(item.provider))) {
                                return true;
                            }
                            const key = DOOH_TARGETING_IDS[filter.targeting_id];
                            if (!key || !Array.isArray(filter.value)) return true;

                            const itemValue = String(item[key]);
                            const match = filter.value.map(String).includes(itemValue);
                            return filter.exclude ? !match : match;
                        });
                    });

                    const polygonIncludes = filters.find(f => f.targeting_id === 'VGA8v9' && f.exclude === false);
                    const polygonExcludes = filters.find(f => f.targeting_id === 'VGA8v9' && f.exclude === true);

                    if (polygonIncludes?.value?.features?.length) {
                        newData = applyPolygonFilter(newData, polygonIncludes.value.features, true);
                    }

                    if (polygonExcludes?.value?.features?.length) {
                        newData = applyPolygonFilter(newData, polygonExcludes.value.features, false);
                    }
                    let retailF = []
                    let doohF = []
                    const radiusFilter = filters.find(f => f.targeting_id === 'radius_r');
                    if (radiusFilter && Array.isArray(radiusFilter.value) && radiusFilter.value.length) {
                        // Convert all radius values to numbers in meters
                        const radiusOptions = radiusFilter.value
                            .map(v => {
                                const lower = v.toLowerCase();
                                if (lower.endsWith("km")) {
                                    return parseFloat(lower) * 1000;
                                }
                                if (lower.endsWith("m")) {
                                    return parseFloat(lower);
                                }
                                return parseFloat(lower); // fallback
                            })
                            .filter(r => !isNaN(r));

                        const retailers = config.mediumrare ? newData.filter(item => item.type === 'retailers') : newData.filter(item => item.type === 'retailers' && KINGLIVINGSKIP.includes(item.provider));
                        const dooh = newData.filter(item => item.type === 'dooh');


                        const filteredDooh = dooh.filter(doohItem => {
                            return retailers.some(retailItem => {
                                const dist = haversineDistance(
                                    parseFloat(doohItem.latitude),
                                    parseFloat(doohItem.longitude),
                                    parseFloat(retailItem.latitude),
                                    parseFloat(retailItem.longitude)
                                );
                                return radiusOptions.some(radius => dist <= radius);
                            });
                        });
                        retailF = [...retailers]
                        doohF = [...filteredDooh];
                    }
                    const radiusFilterC = filters.find(f => f.targeting_id === 'radius_c');
                    if (radiusFilterC && Array.isArray(radiusFilterC.value) && radiusFilterC.value.length) {
                        // Convert all radius values to numbers in meters
                        const radiusOptions = radiusFilterC.value
                            .map(v => {
                                const lower = v.toLowerCase();
                                if (lower.endsWith("km")) {
                                    return parseFloat(lower) * 1000;
                                }
                                if (lower.endsWith("m")) {
                                    return parseFloat(lower);
                                }
                                return parseFloat(lower); // fallback
                            })
                            .filter(r => !isNaN(r));

                        const retailers = newData.filter(item => item.type === 'retailers' && CONQUESTSKIP.includes(item.provider));
                        const dooh = newData.filter(item => item.type === 'dooh');

                        const filteredDooh = dooh.filter(doohItem => {
                            return retailers.some(retailItem => {
                                const dist = haversineDistance(
                                    parseFloat(doohItem.latitude),
                                    parseFloat(doohItem.longitude),
                                    parseFloat(retailItem.latitude),
                                    parseFloat(retailItem.longitude)
                                );
                                return radiusOptions.some(radius => dist <= radius);
                            });
                        });

                        retailF = [...retailF, ...retailers]
                        doohF = [...doohF, ...filteredDooh];
                    }

                    if (radiusFilterC || radiusFilter) {
                        newData = [...retailF, ...doohF];
                    }

                    let targeting = createTargeting(newData, true)
                    let forecast = createForecast(newData)
                    dispatch({
                        type: AllContextualConstants.BB_GET_DOOH_TARGETS_SUCCESS,
                        payload: targeting,
                    });
                    dispatch({
                        type: AllContextualConstants.BB_GET_DOOH_ORIGINAL_TARGETS_SUCCESS,
                        payload: targeting
                    });
                    dispatch({
                        type: AllContextualConstants.BB_GET_DOOH_FORECAST_SUCCESS,
                        payload: forecast,
                    });
                    dispatch(loading(false));
                    dispatch(loadingForecast(false));
                }
            })

    }
    else if (filters && newLoc) {
        let newData = newLoc
        newData = newLoc.filter(item => {
            return filters.every(filter => {
                // only apply provider_d to dooh items
                if (filter.targeting_id === 'extention') {
                    return true;
                }
                if (filter.targeting_id === 'provider_d' && item.type !== 'dooh') {
                    return true;
                }
                // only apply provider_r to retailers
                if (filter.targeting_id === 'provider_r' && (item.type !== 'retailers' || CONQUESTSKIP.includes(item.provider))) {
                    return true;
                }
                if (filter.targeting_id === 'conquest' && (item.type !== 'retailers' || KINGLIVINGSKIP.includes(item.provider))) {
                    return true;
                }
                const key = DOOH_TARGETING_IDS[filter.targeting_id];
                if (!key || !Array.isArray(filter.value)) return true;

                const itemValue = String(item[key]);
                const match = filter.value.map(String).includes(itemValue);
                return filter.exclude ? !match : match;
            });
        });

        const polygonIncludes = filters.find(f => f.targeting_id === 'VGA8v9' && f.exclude === false);
        const polygonExcludes = filters.find(f => f.targeting_id === 'VGA8v9' && f.exclude === true);

        if (polygonIncludes?.value?.features?.length) {
            newData = applyPolygonFilter(newData, polygonIncludes.value.features, true);
        }

        if (polygonExcludes?.value?.features?.length) {
            newData = applyPolygonFilter(newData, polygonExcludes.value.features, false);
        }
        let retailF = []
        let doohF = []
        const radiusFilter = filters.find(f => f.targeting_id === 'radius_r');
        if (radiusFilter && Array.isArray(radiusFilter.value) && radiusFilter.value.length) {
            // Convert all radius values to numbers in meters
            const radiusOptions = radiusFilter.value
                .map(v => {
                    const lower = v.toLowerCase();
                    if (lower.endsWith("km")) {
                        return parseFloat(lower) * 1000;
                    }
                    if (lower.endsWith("m")) {
                        return parseFloat(lower);
                    }
                    return parseFloat(lower); // fallback
                })
                .filter(r => !isNaN(r));

            const retailers = config.mediumrare ? newData.filter(item => item.type === 'retailers') : newData.filter(item => item.type === 'retailers' && (KINGLIVINGSKIP.includes(item.provider)));
            const dooh = newData.filter(item => item.type === 'dooh');

            const filteredDooh = dooh.filter(doohItem => {
                return retailers.some(retailItem => {
                    const dist = haversineDistance(
                        parseFloat(doohItem.latitude),
                        parseFloat(doohItem.longitude),
                        parseFloat(retailItem.latitude),
                        parseFloat(retailItem.longitude)
                    );
                    return radiusOptions.some(radius => dist <= radius);
                });
            });
            retailF = [...retailers]
            doohF = [...filteredDooh];
        }
        const radiusFilterC = filters.find(f => f.targeting_id === 'radius_c');
        if (radiusFilterC && Array.isArray(radiusFilterC.value) && radiusFilterC.value.length) {
            // Convert all radius values to numbers in meters
            const radiusOptions = radiusFilterC.value
                .map(v => {
                    const lower = v.toLowerCase();
                    if (lower.endsWith("km")) {
                        return parseFloat(lower) * 1000;
                    }
                    if (lower.endsWith("m")) {
                        return parseFloat(lower);
                    }
                    return parseFloat(lower); // fallback
                })
                .filter(r => !isNaN(r));

            const retailers = newData.filter(item => item.type === 'retailers' && CONQUESTSKIP.includes(item.provider));
            const dooh = newData.filter(item => item.type === 'dooh');

            const filteredDooh = dooh.filter(doohItem => {
                return retailers.some(retailItem => {
                    const dist = haversineDistance(
                        parseFloat(doohItem.latitude),
                        parseFloat(doohItem.longitude),
                        parseFloat(retailItem.latitude),
                        parseFloat(retailItem.longitude)
                    );
                    return radiusOptions.some(radius => dist <= radius);
                });
            });
            retailF = [...retailF, ...retailers]
            doohF = [...doohF, ...filteredDooh];
        }
        if (radiusFilterC || radiusFilter) {
            newData = [...retailF, ...doohF];
        }

        let targeting = createTargeting(newData)
        let forecast = createForecast(newData)
        dispatch({
            type: AllContextualConstants.BB_GET_DOOH_TARGETS_SUCCESS,
            payload: targeting,
        });
        dispatch({
            type: AllContextualConstants.BB_GET_DOOH_FORECAST_SUCCESS,
            payload: forecast,
        });
        dispatch(loading(false));
        dispatch(loadingForecast(false));

    }
    else {
        axios.get(`${ROOT_URL_API}/get_dooh_locations?provider=${provider}`, {
            headers: { Authorization: config.authToken() },
        })
            .then((response) => {
                if (response?.data?.success) {
                    let locations = response.data.data

                    let targeting = createTargeting(locations, true)
                    let forecast = createForecast(locations)

                    dispatch({
                        type: AllContextualConstants.BB_GET_DOOH_TARGETS_SUCCESS,
                        payload: targeting,
                    });
                    dispatch({
                        type: AllContextualConstants.BB_GET_DOOH_ORIGINAL_TARGETS_SUCCESS,
                        payload: targeting
                    });
                    dispatch({
                        type: AllContextualConstants.BB_GET_DOOH_FORECAST_SUCCESS,
                        payload: forecast,
                    });

                } else {
                    dispatch({
                        type: AllContextualConstants.BB_GET_DOOH_TARGETS_ERROR,
                        payload: "",
                    });
                    dispatch({
                        type: AllContextualConstants.BB_GET_DOOH_FORECAST_ERROR,
                        payload: "",
                    });
                }
                dispatch(loading(false));
                dispatch(loadingForecast(false));

            })
            .catch((error) => {
                dispatch({
                    type: AllContextualConstants.BB_GET_DOOH_TARGETS_ERROR,
                    payload: "",
                })
                dispatch({
                    type: AllContextualConstants.BB_GET_DOOH_FORECAST_ERROR,
                    payload: "",
                });
                dispatch(loading(false));
                dispatch(loadingForecast(false));

            }
            );
    }


}
export const getTargetingValuesCommbank = (targetdata, targetId, kingliving = false) => (dispatch) => {
    dispatch(loadingValues(true));
    const key = DOOH_TARGETING_IDS[targetId];
    if (!key) {
        dispatch({
            type: AllContextualConstants.BB_GET_DOOH_VALUES_ERROR,
            payload: "",
        });
        dispatch(loadingValues(false));
    }
    let uniqueValues = []
    if (targetId === "mGRJG2") {
        uniqueValues = WEATHER
    }
    else if (targetId === "extension") {
        uniqueValues = EXTENTION
    }
    else if (targetId === "commbankme") {
        uniqueValues = COMMBANK_ME
    }
    else if (targetId === "provider_r") {
        uniqueValues = RETAIL
        if (config.woolworths) {
            uniqueValues = RETAILWOOL
        }
        else if (kingliving) {
            uniqueValues = RETAILKING
        }
    }
    else if (targetId === "conquest") {
        if (config.woolworths) {
            uniqueValues = CONQUESTWOOL
        }
        else if (kingliving) {
            uniqueValues = CONQUEST
        }
    }
    else if (targetId === "radius_r") {
        uniqueValues = RADIUS
    }
    else if (targetId === "provider_d") {
        const countMap = targetdata
            .filter(item => item.type === "dooh" && item[key])
            .reduce((acc, item) => {
                const val = String(item[key]);
                acc[val] = (acc[val] || 0) + 1;
                return acc;
            }, {});
        uniqueValues = Array.from(
            new Set(
                targetdata
                    .filter(item => item.type === "dooh")
                    .map(item => item[key])
                    .filter(Boolean)
            )
        );
        uniqueValues = uniqueValues.map(value => ({
            id: String(value),
            text: String(value),
            count: countMap[String(value)] || 0
        }));
    }
    else {
        uniqueValues = Array.from(
            new Set(targetdata.map(item => item[key]).filter(Boolean))
        );

        uniqueValues = uniqueValues.map(value => ({
            id: String(value),
            text: String(value)
        }));
        if (targetId === "NGNDgB") {
            uniqueValues = [...uniqueValues]
        }
    }
    dispatch({
        type: AllContextualConstants.BB_GET_DOOH_VALUES_SUCCESS,
        payload: { values: uniqueValues },
    });
    dispatch(loadingValues(false));

};